export default __webpack_public_path__ + "static/media/apr2024-1.e433af18.jpg";